<template>
	<div class="imgContainer">
		<img :src="selected" />
	</div>
</template>

<script>
export default {
	created() {
		this.selected = this.sources[1];
		this.selectNext(2);
	},
	data() {
		return {
			selected: "",
			sources: {
				1: "https://firebasestorage.googleapis.com/v0/b/alduin-app.appspot.com/o/assets%2F1.png?alt=media&token=b8a8382a-cf49-486b-87e7-7b3700aee3a2",
				2: "https://firebasestorage.googleapis.com/v0/b/alduin-app.appspot.com/o/assets%2F2.png?alt=media&token=0954a691-d370-4e09-8a9d-1fcbeaa3c0d1",
			},
		};
	},
	methods: {
		selectNext(index) {
			setTimeout(() => {
				this.selected = this.sources[index];
				const next = index !== 2 ? index + 1 : 1;
				this.selectNext(next);
			}, 3000);
		},
	},
};
</script>

<style scoped>
.imgContainer {
	width: 50%;
}
img {
	width: 420px;
}

@media only screen and (max-width: 750px) {
	.imgContainer {
		width: 100%;
		padding-bottom: 150px;
	}
	img {
		width: 100%;
	}
}
</style>
